// This is just for quick confirmations - for more complex ones, use the useConfirmation hook

import { useConfirmation } from "./useConfirmation"
import { ConfirmCancelDialogue } from "../Components/ConfirmCancelDialogue"
import React from "react"
import { IComponentProp } from "@cd2/tools"
import { brandColors } from "../Components/EOSThemeProvider"

export function useConfirmCancelConfirmation({
  heading,
  body,
  buttonOpts,
}: {
  heading: React.ReactNode
  body?: React.ReactNode
  buttonOpts?: IComponentProp<typeof ConfirmCancelDialogue, "buttonOpts">
}) {
  const confirmationFunction = useConfirmation<void, boolean>(({ onResolve }) => (
    <ConfirmCancelDialogue
      heading={heading}
      body={body}
      onConfirm={() => onResolve(true)}
      onCancel={() => onResolve(false)}
      buttonOpts={buttonOpts}
      isOpen
    />
  ))

  return confirmationFunction
}

export function useConfirmDelete(args?: { heading?: React.ReactNode; body?: React.ReactNode }) {
  return useConfirmCancelConfirmation({
    buttonOpts: { confirm: { children: "Delete", buttonColor: brandColors.blaze } },
    heading: args?.heading || "Are you sure you wish to delete this?",
    body: args?.body || "This action cannot be undone.",
  })
}

export function useConfirm() {
  const confirmationFunction = useConfirmation<{ heading: string; body: string }, boolean>(
    ({ data, onResolve }) => (
      <ConfirmCancelDialogue
        heading={data.heading}
        body={data.body}
        onConfirm={() => onResolve(true)}
        onCancel={() => onResolve(false)}
        isOpen
      />
    ),
  )

  return confirmationFunction
}
